import { ROUTE_PATH_ADMIN } from '../../configRoutes';

export const ROUTE_PATH_DASHBOARD = ROUTE_PATH_ADMIN + '/dashboard';
